export default __webpack_public_path__ + "static/media/0.38d1fe80.jpg";